import { render, staticRenderFns } from "./paymentLink.vue?vue&type=template&id=40284cb2&scoped=true"
import script from "./paymentLink.vue?vue&type=script&lang=js"
export * from "./paymentLink.vue?vue&type=script&lang=js"
import style0 from "./paymentLink.vue?vue&type=style&index=0&id=40284cb2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40284cb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40284cb2')) {
      api.createRecord('40284cb2', component.options)
    } else {
      api.reload('40284cb2', component.options)
    }
    module.hot.accept("./paymentLink.vue?vue&type=template&id=40284cb2&scoped=true", function () {
      api.rerender('40284cb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/sub-merchant/components/content/payment-link/components/tabs/paymentLink.vue"
export default component.exports